import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { getRouteProperties } from "components/NavBar/routes";
import { usePermanentSession } from "modules/Login/hooks";

type SidebarProps = {
  openSidebar?: () => void;
};

export const Sidebar = ({ openSidebar }: SidebarProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const { session } = usePermanentSession();

  return (
    <div className="nav-bar-start">
      {!session?.appointment_id && (
        <div className="pointer" onClick={openSidebar}>
          <Icon name="bars" color="black" />
        </div>
      )}
      <div className="route-text">
        {getRouteProperties(t, location).title} <span id="navbar-count-portal-container" />
      </div>
    </div>
  );
};
